/** Canonical labels — spec §3.2–§3.6. Read these instead of typing the words. */
export const PAGE = {
    dashboard: 'Dashboard',
    myShifts: 'My shifts',
    creditTransactions: 'Credit transactions',
    cashTransactions: 'Cash transactions',
    usdWalletTransactions: 'USD wallet transactions',
    withdrawalRequests: 'Withdrawal requests',
    redemptionApprovals: 'Redemption approvals',
    agents: 'Agents',
    shops: 'Shops',
    cashiers: 'Cashiers',
    players: 'Players',
    gameWallets: 'Game wallets',
    fraudIndicators: 'Fraud indicators',
    shifts: 'Shifts',
    devices: 'Devices',
    shiftExceptions: 'Shift exceptions',
    shiftReports: 'Shift reports',
    shiftReconciliation: 'Shift reconciliation',
    shiftDetails: 'Shift details',
    popups: 'Popups',
    broadcasts: 'Broadcasts',
    emailSms: 'Email & SMS',
    feeConfiguration: 'Fee configuration',
    settings: 'Settings',
    kioskUrl: 'Kiosk URL',
};
export const GROUP = {
    approvals: 'Approvals',
    network: 'Network',
    cashiers: 'Cashiers',
    transactions: 'Transactions',
    messages: 'Messages',
    settings: 'Settings',
};
export const MONEY = {
    creditBalance: 'Credit balance',
    usdWalletBalance: 'USD wallet balance',
    addUsd: 'Add USD',
    buyCredits: 'Buy credits',
    sellCredits: 'Sell credits',
    withdrawCredits: 'Withdraw credits',
    requestPayout: 'Request payout',
    payout: 'Payout',
    deposit: 'Deposit',
    redeem: 'Redeem',
    depositCredits: 'Deposit credits',
    redeemCredits: 'Redeem credits',
    counterDeposit: 'Counter deposit',
    counterRedemption: 'Counter redemption',
    counterDeposits: 'Counter deposits',
    counterRedemptions: 'Counter redemptions',
    creditsBought: 'Credits bought',
    creditsSold: 'Credits sold',
    creditsWithdrawnBack: 'Credits withdrawn back',
    costRate: 'Cost rate',
    onlineDebt: 'Outstanding online debt',
};
export const SHIFT = {
    scheduleShift: 'Schedule shift',
    startShift: 'Start shift',
    continueShift: 'Continue shift',
    viewShift: 'View shift',
    cashDrop: 'Cash drop',
    endShift: 'End shift',
    openingCount: 'Opening count',
    closingCount: 'Closing count',
    handover: 'Handover',
    reconcileShift: 'Reconcile shift',
    openingCash: 'Opening cash',
    expectedCash: 'Expected cash',
    countedCash: 'Counted cash',
    discrepancy: 'Discrepancy',
};
export const ACTION = {
    signIn: 'Sign in',
    signOut: 'Sign out',
    backToSignIn: 'Back to sign in',
    forgotPassword: 'Forgot password?',
    apply: 'Apply',
    reset: 'Reset',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    approve: 'Approve',
    reject: 'Reject',
    suspend: 'Suspend',
    reactivate: 'Reactivate',
    terminate: 'Terminate',
    viewDetails: 'View details',
    more: 'More',
    exportCsv: 'Export CSV',
    refresh: 'Refresh',
    backToDashboard: 'Back to Dashboard',
};
